import styled, { FlattenSimpleInterpolation, css } from 'styled-components';
import { resetAnchor } from '../../link-button'; // TODO: put this in a common file
import { bodySmall } from '../../paragraph'; // TODO: put this in a common file

export const StyledTab = styled.div<{
  selected?: boolean;
  width?: number;
  disabled: boolean;
}>`
  ${resetAnchor};
  ${bodySmall};
  flex: 1;
  max-width: ${({ width = 300 }): string => `${width}px`};
  text-align: center;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }): string => theme.border_radius_x1};
  background-color: ${({ theme, selected }): string =>
    selected ? theme.palette_blue_100 : theme.palette_blue_0};
  color: ${({ theme, selected }): string =>
    selected ? theme.palette_white : theme.palette_blue_100};
  transition: background-color 250ms ease;

  &:hover {
    background-color: ${({ theme, selected }): string =>
      selected ? theme.palette_blue_100 : theme.palette_blue_5};
  }

  ${({ theme, disabled }): FlattenSimpleInterpolation | undefined => {
    if (disabled === false) {
      return;
    }

    return css`
      cursor: not-allowed;
      background-color: ${theme.palette_gray_5};
      color: ${theme.palette_gray_60};

      &:hover {
        background-color: ${theme.palette_gray_5};
        color: ${theme.palette_gray_60};
      }
    `;
  }}

  ${({ theme }): FlattenSimpleInterpolation => css`
    @media (max-width: ${theme.breakpoints_sm}) {
      height: 50px;
    }
  `}
`;
